/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';

import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class UnlinkedPostsRoute extends Route {
  // Services
  @service
  store;

  model() {
    let person = this.modelFor('people.person').person;
    let pageModel = this.modelFor('people.person.page');
    let page = pageModel.page;
    let assessments = page.assessment_ids;
    // assessments is a fragment array: spread it, or stringify reaches the store.
    let assessmentIds = JSON.stringify([...assessments]);

    return hash({
      person,
      page,

      modules: this.store.query('assessments/module', {
        assessmentIds,
        include: 'gradeSchedules',
      }),
      posts: this.store.query('posts/post', {
        personId: person.id,
        pageId: page.id,
        include: 'reactions,comments',
      }),
    });
  }
}
